import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerFilterPipe } from './customer-filter.pipe';
import { JoinPipe } from './join.pipe';
import { KeyValueFilterPipe } from './key-value-filter.pipe';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { StringDateFormatterPipe } from './string-date-formatter.pipe';
import { SlugifyPipe } from './slugify.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule
  ],
  declarations: [CustomerFilterPipe, JoinPipe, KeyValueFilterPipe, StringDateFormatterPipe, SlugifyPipe],
  exports: [CustomerFilterPipe, JoinPipe, KeyValueFilterPipe, StringDateFormatterPipe, SlugifyPipe]
})
export class PipesModule { }
